//
//
//
//
//
//

export default {
  name: 'App',
  mounted () {
  }
}



// WEBPACK FOOTER //
// ./src/App.vue